import React, { useState } from "react";

import NotificationContext from "./NotificationContext";
import DefaultNotificationView from "./DefaultNotificationView";
import {
  IDuration,
  IBannerStyle,
  INotificationBannerProps,
} from "./typeDefinition";

const NotificationProvider: React.FC = ({ children }) => {
  const [notificationSettings, setNotificationSettings] = useState<
    INotificationBannerProps | any
  >({});

  function handleSetNotificationSettings(
    message?: string,
    description?: string,
    style?: IBannerStyle,
    duration?: IDuration
  ) {
    setNotificationSettings({
      id: Date.now(),
      message,
      description,
      style,
      duration,
    });
  }

  return (
    <NotificationContext.Provider
      value={{
        notificationSettings,
        onSetNotificationSettings: handleSetNotificationSettings,
      }}
    >
      <DefaultNotificationView
        id={notificationSettings.id}
        message={notificationSettings.message}
        description={notificationSettings.description}
        style={notificationSettings.style}
        duration={notificationSettings.duration}
      />
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
